import get from "lodash/get";
import { getAssetURLMapping, getEntryURLMapping } from "./assets";

export const buildHomePageTiles = async (data, isWebPSupported) => {
  const assetURLsByID = getAssetURLMapping(data.data, isWebPSupported);
  const entryByID = getEntryURLMapping(data.data);
  const tileLinks = get(data, "data.items[0].fields.homePageTiles", []) || [];

  const referenceTiles = tileLinks
    .map((tile) => entryByID[get(tile, "sys.id")])
    .filter(Boolean)
    .map((tile) => buildTile(tile, assetURLsByID, entryByID));

  // Separate types
  const projectTiles = referenceTiles.filter((t) => t.type === "project");
  const pressTiles = referenceTiles.filter((t) => t.type === "publication");

  // Inject first press tile after the first project tile
  if (pressTiles.length > 0) {
    projectTiles.splice(1, 0, pressTiles[0]);
  }

  return projectTiles;
};

//
// ─────────────────────────────────────────────────────────
// Helper: Creates a tile object from a Contentful entry
// ─────────────────────────────────────────────────────────
//
function buildTile(referenceTile, assetURLsByID, entryByID) {
  const isProject = !!get(referenceTile, "fields.projectTitle");
  const fields = referenceTile.fields || {};

  const slug =
    fields.projectTitle ||
    fields.publicationTitle ||
    fields.publicationDate ||
    "";

  const url = isProject
    ? `/project/${slug.replaceAll(" ", "-").trim().toLowerCase()}`
    : fields.publicationUrl;

  const title = formatTitle(
    fields.projectTitle || fields.publicationTitle || ""
  );

  const { linkTileImage, imageTile, portraitFallback } = extractImages(
    fields.featureImages || [],
    entryByID,
    assetURLsByID
  );

  const fallbackPublicationImage =
    assetURLsByID[get(referenceTile, "fields.homePageTileImage.sys.id")];

  return {
    title,
    url,
    linkTileImage:
      linkTileImage || portraitFallback || fallbackPublicationImage,
    imageTile,
    type: isProject ? "project" : "publication",
  };
}

//
// ─────────────────────────────────────────────────────────
// Helper: Extract relevant tile images from featureImages[]
// ─────────────────────────────────────────────────────────
//
function extractImages(featureImages, entryByID, assetURLsByID) {
  let linkTileImage = null;
  let imageTile = null;
  let portraitFallback = null;

  featureImages.forEach((entryLink) => {
    const entryId = get(entryLink, "sys.id");
    const entry = entryByID[entryId];
    if (!entry) return;

    const assetId = get(entry, "fields.featureImage.sys.id");
    const assetURL = assetURLsByID[assetId];
    if (!assetURL) return;

    const orientation = get(entry, "fields.imageOrientation");

    switch (orientation) {
      case "Homepage Link Tile Image":
        linkTileImage = assetURL;
        break;
      case "Homepage Supporting Image":
        imageTile = assetURL;
        break;
      case "Portrait":
        portraitFallback = assetURL;
        break;
      default:
        portraitFallback = assetURL;
        break;
    }
  });

  return { linkTileImage, imageTile, portraitFallback };
}

//
// ─────────────────────────────────────────────────────────
// Helper: Formats title (title-case logic)
// ─────────────────────────────────────────────────────────
//
function formatTitle(title) {
  return title.replace(
    /(^\w|\s\w)(\S*)/g,
    (_, first, rest) => first.toUpperCase() + rest.toLowerCase()
  );
}
